export const SET_SIGNBOOK = 'SET_SIGNBOOK';
export const SET_SIGNWORKFLOWS = 'SET_SIGNWORKFLOWS';
export const SET_STATUS = 'SET_STATUS';
export const RESET_SIGNWORKFLOWS = 'RESET_SIGNWORKFLOWS';
export const SET_SIGNWORKFLOWS_SEARCH_PARAMS = 'SET_SIGNWORKFLOWS_SEARCH_PARAMS';
export const ADD_SIGNATORY_DESKRH_EMP_CREATION = 'ADD_SIGNATORY_DESKRH_EMP_CREATION';
